<template>
  <v-app>
    <div class="fondo">
      <div class="imagen_fondo" />
    </div>

    <router-view />

    <div v-if="$global.cargando" class="pantalla_carga">
      <div class="fondo_pantalla_carga"></div>
      <div class="centrar_vertical text-center">
        <v-progress-circular :size="70" :width="7" color="#bead87" indeterminate></v-progress-circular>
      </div>
    </div>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-app>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";
import { Plugins } from "@capacitor/core";

const { Keyboard } = Plugins;

export default {
  name: "VueApp",

  components: { ConfirmDialog },

  data: () => ({
    //
  }),


  created() {
    // configuramos eventos de teclado: Despues de mostrarse / Antes de ocultarse
    Keyboard.addListener("keyboardDidShow", (info) => {
      let div = document.getElementById("div_espacio_teclado");
      div.style = "height: " + info.keyboardHeight + "px";
    });
    Keyboard.addListener("keyboardWillHide", () => {
      let div = document.getElementById("div_espacio_teclado");
      div.style = "";
    });
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;
  }
};
</script>

<style>
@import "../node_modules/typeface-roboto/index.css";

* {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
input {
  -webkit-user-select: auto !important;
  -khtml-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  user-select: auto !important;
}

.fondo {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  background-image: linear-gradient(black, #002050);
}
.imagen_fondo {
  width: 100%;
  height: 100%;
  background-image: url("./assets/fondo_login.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.1;
}
.area_pantalla {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.scroll_vertical {
    position: absolute;
    top: 0px;
    bottom: -16px;
    left: 0px;
    right: -16px;
    overflow-y: auto;
    overflow-x: hidden;
}
.centrar_vertical {
  position: absolute;
  width: 100%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.pantalla_carga {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
}
.fondo_pantalla_carga {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.7;
}
</style>